"use strict";

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Tooltip;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _MarkdownHtml = _interopRequireDefault(require("./MarkdownHtml"));

var _reactLaag = require("react-laag");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function CloseIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5277 1.84289C11.694 1.68515 11.694 1.42021 11.5277 1.26248L10.9339 0.699235C10.7796 0.552844 10.5377 0.552844 10.3834 0.699235L6.00033 4.85687L1.61727 0.699235C1.46295 0.552844 1.22104 0.552844 1.06671 0.699235L0.472933 1.26247C0.306642 1.42021 0.306642 1.68515 0.472933 1.84289L4.82533 5.97144L0.472933 10.1C0.306642 10.2577 0.306642 10.5227 0.472933 10.6804L1.06671 11.2437C1.22104 11.39 1.46295 11.39 1.61727 11.2437L6.00033 7.08602L10.3834 11.2437C10.5377 11.39 10.7796 11.39 10.9339 11.2437L11.5277 10.6804C11.694 10.5227 11.694 10.2577 11.5277 10.1L7.17533 5.97144L11.5277 1.84289Z",
    fill: "#1A1A1A"
  }));
}

var TooltipWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Tooltip__TooltipWrapper"
})(["background-color:#ebefff;min-width:200px;max-width:300px;z-index:10;border-radius:4px;box-shadow:2px 2px 2px #e7e7e7;padding:0.5rem 1rem 0.5rem 1rem;& strong{display:block;font-weight:700;font-size:14px;text-transform:uppercase;}& .title{width:100%;display:flex;align-items:baseline;justify-content:space-between;}& p{color:#1a1a1a !important;font-weight:400 !important;text-transform:none !important;font-size:0.9rem !important;font-weight:300 !important;}"]);

var TransparentBtn = _styledComponents["default"].button.attrs({
  type: 'button'
}).withConfig({
  displayName: "Tooltip__TransparentBtn"
})(["background:transparent;border:0;"]);

function Tooltip(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-center' : _ref$placement,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? '' : _ref$content,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      children = _ref.children,
      _ref$triggerOffset = _ref.triggerOffset,
      triggerOffset = _ref$triggerOffset === void 0 ? 10 : _ref$triggerOffset;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useLayer = (0, _reactLaag.useLayer)({
    isOpen: isOpen,
    placement: placement,
    triggerOffset: triggerOffset,
    onOutsideClick: function onOutsideClick() {
      return setIsOpen(false);
    }
  }),
      triggerProps = _useLayer.triggerProps,
      layerProps = _useLayer.layerProps,
      renderLayer = _useLayer.renderLayer;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TransparentBtn, {
    ref: triggerProps.ref,
    style: triggerProps.style,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, children), isOpen && renderLayer( /*#__PURE__*/_react["default"].createElement(TooltipWrapper, {
    ref: layerProps.ref,
    style: layerProps.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, title), /*#__PURE__*/_react["default"].createElement(TransparentBtn, {
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, null))), content && /*#__PURE__*/_react["default"].createElement(_MarkdownHtml["default"], null, content))));
}

Tooltip.propTypes = {
  content: _propTypes["default"].string,
  title: _propTypes["default"].string,
  placement: _propTypes["default"].oneOf(['top-center', 'top-start', 'top-end', 'left-start', 'left-center', 'left-end', 'right-start', 'right-center', 'right-end', 'bottom-start', 'bottom-center', 'bottom-end', 'center'])
};